// src/components/common/EmailInput.tsx
import React from 'react';

interface EmailInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  required?: boolean;
  error?: string;
  placeholder?: string;
  className?: string;
}

export const EmailInput: React.FC<EmailInputProps> = ({
  value,
  onChange,
  label,
  required = false,
  error,
  placeholder = 'you@example.com',
  className = '',
}) => {
  const validateEmail = (email: string) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const showError = error || (value && !validateEmail(value));

  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type="email"
        value={value}
        onChange={handleChange}
        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
          showError ? 'border-red-500' : 'border-gray-300'
        }`}
        placeholder={placeholder}
        required={required}
      />
      {showError && (
        <p className="mt-1 text-sm text-red-600">
          {error || 'Please enter a valid email address'}
        </p>
      )}
    </div>
  );
};